import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useRenameDocumentMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setDisabled, setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const renameDocument = async (documentId, path) => {
    const url = encodeURI(`${env.apiUrl}/documents/${documentId}`)
    const response = await securedFetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: path })
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ documentId, path }) => renameDocument(documentId, path),
    onMutate: () => {
      progressStart()
      setDisabled(true)
    },
    onError: (error) => handleError(error, 'Error renaming document'),
    onSuccess: () => {
      queryClient.invalidateQueries('documents')
      setMessage('Document was renamed')
    },
    onSettled: () => {
      progressEnd()
      setDisabled(false)
    }
  })
}

export { useRenameDocumentMutation }
